import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fcp-survey-bullet',
  templateUrl: './bullet.component.html',
  styleUrls: ['./bullet.component.scss']
})
export class BulletComponent implements OnInit {
  @Input() selected: number;
  @Input() questions;

  constructor() { }

  ngOnInit() {
  }

}
